import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Typography } from '../../../../Typography';
import { renderDate } from './DateCell.utils';
export function DateCell(param) {
    let { value, format, now, emptyText, textSkin, testId } = param;
    const date = value instanceof Date ? value : undefined;
    return /*#__PURE__*/ _jsx(Typography, {
        ellipsis: true,
        skin: date == null ? 'disabled' : textSkin,
        testId: testId,
        children: date == null ? emptyText : renderDate({
            value: date,
            format,
            now
        })
    });
}
